import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { Pageable, ResponseData, SortDirectionType } from "services/common"

export type ReviewStatus =
  | "UNREVIEWED"
  | "CONFIRMED"
  | "TRAVELER_ACTION_NEEDED"
  | "CHECK_IN_INSTRUCTIONS_NEEDED"
  | "POTENTIAL_ISSUE"
  | "HOST_ACTION_NEEDED"

export type ActionStatus = "NOT_NEEDED" | "TO_DO" | "DONE"

export interface CheckInRow {
  booking_id: string
  traveler_name: string
  pmc_name: string
  health_score: number
  booking_value: number
  pmc_id: string
  risks: string
  check_in_date: number
  review_status: ReviewStatus
  action_status: ActionStatus | null
  notes: string
  last_review_date: number
}

export interface CheckInsStatCards {
  total_checkins: number
  total_booking_risks: number
  total_no_comms_count: number
  total_low_pmc_health_count: number
}

interface CheckInsPage extends Pageable {
  content: CheckInRow[]
}

interface GetCheckInsResponseData extends ResponseData {
  data: {
    checkins_data: CheckInsPage
    stat_cards: CheckInsStatCards
  }
}

interface GetCheckInsResponse extends AxiosResponse {
  data: GetCheckInsResponseData
}

export interface GetCheckInsRequest extends Partial<AxiosRequestConfig> {
  params: {
    startDt: string
    endDt: string
    pmcId: string
    noCommunication?: boolean
    lowPMCHealth?: boolean
    noRisk?: boolean
    pageNo: number
    noOfRecords: number
    sortBy: string
    sortDirection: SortDirectionType
    reviewStatus: ReviewStatus | string
  }
}

export function getCheckInsApi(
  { params, ...config }: GetCheckInsRequest,
  axiosInstance: AxiosInstance,
): Promise<GetCheckInsResponse> {
  return axiosInstance({
    method: "get",
    params,
    url: `newadmin/check-ins`,
    ...config,
  })
}

// ----------- update dropdown value API -------------------------

interface UpdateCheckInRequest extends Partial<AxiosRequestConfig> {
  params: {
    bookingId: string
    reviewStatus?: ReviewStatus | null | undefined
    actionStatus?: ActionStatus | null | undefined
    notes?: string | undefined
  }
}

interface UpdateCheckInResponseData extends AxiosResponse {
  data: string
}

interface UpdateCheckInResponse extends AxiosResponse {
  data: UpdateCheckInResponseData
}

export function updateCheckInApi(
  { params, ...config }: UpdateCheckInRequest,
  axiosInstance: AxiosInstance,
): Promise<UpdateCheckInResponse> {
  return axiosInstance({
    method: "put",
    url: "newadmin/update-check-in",
    params,
    ...config,
  })
}
